import type { ReactNode } from "react";
import { timeline } from "@web/theme/theme";
import { Text } from "./Text";

export type TimelineItemProps = { icon: ReactNode; title: ReactNode; body?: ReactNode; meta?: ReactNode; last?: boolean };

/** One entry of a vertical timeline (Activity now; the lead Timeline later). */
export function TimelineItem({ icon, title, body, meta, last = false }: TimelineItemProps) {
  return (
    <div className={timeline.item}>
      <div className={timeline.rail}>
        <span className={timeline.dot}>{icon}</span>
        {!last && <span className={timeline.line} />}
      </div>
      <div className={timeline.body}>
        <Text variant="body">{title}</Text>
        {body && (
          <Text variant="callout" tone="secondary">
            {body}
          </Text>
        )}
        {meta && (
          <Text variant="caption" tone="tertiary">
            {meta}
          </Text>
        )}
      </div>
    </div>
  );
}
